import advancedFilters from './advancedFilters.json';
import assessments from './assessments.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import bulkActions from './bulkActions.json';
import campaign from './campaign.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import companies from './companies.json';
import components from './components.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import contentTemplates from './contentTemplates.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import customRole from './customRole.json';
import datePicker from './datePicker.json';
import emoji from './emoji.json';
import gallery from './gallery.json';
import general from './general.json';
import generalSettings from './generalSettings.json';
import takeoverRequests from './takeoverRequests.json';
import helpCenter from './helpCenter.json';
import inbox from './inbox.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import interactiveMessage from './interactiveMessage.json';
import kanban from './kanban.json';
import internalChat from './internalChat.json';
import labelsMgmt from './labelsMgmt.json';
import login from './login.json';
import macros from './macros.json';
import mfa from './mfa.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import suggestions from './suggestions.json';
import signup from './signup.json';
import sla from './sla.json';
import snooze from './snooze.json';
import teamsSettings from './teamsSettings.json';
import catalogMgmt from './catalogMgmt.json';
import unitsMgmt from './unitsMgmt.json';
import webhooks from './webhooks.json';
import whatsappTemplates from './whatsappTemplates.json';
import whatsappTemplatesMgmt from './whatsappTemplatesMgmt.json';
import redeSocial from './redeSocial.json';
import yearInReview from './yearInReview.json';

export default {
  ...assessments,
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...bulkActions,
  ...campaign,
  ...cannedMgmt,
  ...chatlist,
  ...companies,
  ...components,
  ...contact,
  ...contactFilters,
  ...contentTemplates,
  ...conversation,
  ...csatMgmt,
  ...customRole,
  ...datePicker,
  ...emoji,
  ...gallery,
  ...general,
  ...generalSettings,
  ...takeoverRequests,
  ...helpCenter,
  ...inbox,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...interactiveMessage,
  ...kanban,
  ...internalChat,
  ...labelsMgmt,
  ...login,
  ...macros,
  ...mfa,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...suggestions,
  ...signup,
  ...sla,
  ...snooze,
  ...teamsSettings,
  ...catalogMgmt,
  ...unitsMgmt,
  ...webhooks,
  ...whatsappTemplates,
  ...whatsappTemplatesMgmt,
  ...redeSocial,
  ...yearInReview,
};
